/* istanbul ignore file */
import _ from 'underscore';
import { WaterfallFilterType } from '@bingads-webui/filter-commons';
import { CampaignType } from '@bingads-webui-react/with-site-map';

const CampaignTypeByEnumValue = {
  "Enum.CampaignType'Default'": CampaignType.Default,
  "Enum.CampaignType'Shopping'": CampaignType.Shopping,
  "Enum.CampaignType'Audience'": CampaignType.Audience,
  "Enum.CampaignType'Smart'": CampaignType.Smart,
  "Enum.CampaignType'Hotel'": CampaignType.Hotel,
  "Enum.CampaignType'PerformanceMax'": CampaignType.PerformanceMax,
  "Enum.CampaignType'App'": CampaignType.App,
  "Enum.CampaignType'LinkedIn'": CampaignType.LinkedIn,
};

export const CampaignTypeToStringMap = {
  [CampaignType.Default]: 'Default',
  [CampaignType.Shopping]: 'Shopping',
  [CampaignType.Audience]: 'Audience',
  [CampaignType.Smart]: 'Smart',
  [CampaignType.Hotel]: 'Hotel',
  [CampaignType.PerformanceMax]: 'PerformanceMax',
  [CampaignType.App]: 'App',
  [CampaignType.LinkedIn]: 'LinkedIn',
};

export function getFilteredCampaignType(rawFilter) {
  const filteredCampainTypes = rawFilter
    && rawFilter.value
    && rawFilter.value.query
    && rawFilter.value.query.CampaignType
    && rawFilter.value.query.CampaignType.$in;

  if (_.isEmpty(filteredCampainTypes)) {
    return CampaignType.All;
  }

  return CampaignTypeByEnumValue[filteredCampainTypes[0]];
}

const CampaignTypeEnumValuePrefix = 'Enum.CampaignType';
function addPrefixToEnumValue(prefix, enumValue) {
  return `${prefix}'${enumValue}'`;
}

export function convertFilteredCampaignTypeToFilter(campaignType) {
  if (campaignType === CampaignType.All) {
    return { key: WaterfallFilterType.CampaignType, value: { query: null } };
  }

  return {
    key: WaterfallFilterType.CampaignType,
    value: {
      query: {
        CampaignType: {
          $in:
            [addPrefixToEnumValue(
              CampaignTypeEnumValuePrefix,
              [CampaignTypeToStringMap[campaignType]]
            )],
        },
      },
    },
  };
}

export function filterMapItem(siteMap, predicate, permissions) {
  return _.reduce(siteMap, (result, item) => {
    if (predicate(item, permissions)) {
      const children = filterMapItem(item.children, predicate, permissions);
      result.push(_.defaults({ children }, item));
    }
    return result;
  }, []);
}

export function campaignTypeFilter(campaignType, { campaignTypes }, permissions) {
  return _.isFunction(campaignTypes) ? campaignTypes(campaignType, permissions) :
    _.some(campaignTypes, type => (type === campaignType) ||
      (type & campaignType)); // eslint-disable-line no-bitwise
}

export function filterMapItemByCampaignType(siteMap, currentCampaignType, permissions) {
  return filterMapItem(siteMap, _.partial(campaignTypeFilter, currentCampaignType), permissions);
}
